import { Injectable, signal, computed, effect, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  private platformId = inject(PLATFORM_ID);
  
  xp = signal(0);
  level = computed(() => Math.floor(this.xp() / 1000) + 1);
  xpToNextLevel = computed(() => (this.level() * 1000) - this.xp());
  levelProgress = computed(() => ((this.xp() % 1000) / 1000) * 100);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.load();
    }
    
    effect(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.save();
      }
    });
  }

  addXp(amount: number) {
    this.xp.update(x => x + amount);
  }

  private load() {
    const saved = localStorage.getItem('kicgle_master_progress');
    if (saved) {
      try {
        const data = JSON.parse(saved);
        this.xp.set(data.xp || 0);
      } catch (e) {
        console.error('Failed to parse progress data', e);
      }
    }
  }

  private save() {
    localStorage.setItem('kicgle_master_progress', JSON.stringify({ xp: this.xp() }));
  }
}
